function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Registry } from '../../registry/common/platform.js';
import { createDecorator } from '../../instantiation/common/instantiation.js';
import { Extensions } from './configurationRegistry.js';
export var IConfigurationService = createDecorator('configurationService');
export function toValuesTree(properties, conflictReporter) {
  var root = Object.create(null);

  for (var key in properties) {
    addToValueTree(root, key, properties[key], conflictReporter);
  }

  return root;
}
export function addToValueTree(settingsTreeRoot, key, value, conflictReporter) {
  var segments = key.split('.');
  var last = segments.pop();
  var curr = settingsTreeRoot;

  for (var i = 0; i < segments.length; i++) {
    var s = segments[i];
    var obj = curr[s];

    switch (typeof obj) {
      case 'undefined':
        obj = curr[s] = Object.create(null);
        break;

      case 'object':
        break;

      default:
        conflictReporter("Ignoring ".concat(key, " as ").concat(segments.slice(0, i + 1).join('.'), " is ").concat(JSON.stringify(obj)));
        return;
    }

    curr = obj;
  }

  if (typeof curr === 'object' && curr !== null) {
    try {
      curr[last] = value; // workaround https://github.com/Microsoft/vscode/issues/13606
    } catch (e) {
      conflictReporter("Ignoring ".concat(key, " as ").concat(segments.join('.'), " is ").concat(JSON.stringify(curr)));
    }
  } else {
    conflictReporter("Ignoring ".concat(key, " as ").concat(segments.join('.'), " is ").concat(JSON.stringify(curr)));
  }
}
export function removeFromValueTree(valueTree, key) {
  var segments = key.split('.');
  doRemoveFromValueTree(valueTree, segments);
}

function doRemoveFromValueTree(valueTree, segments) {
  var first = segments.shift();

  if (segments.length === 0) {
    // Reached last segment
    delete valueTree[first];
    return;
  }

  if (Object.keys(valueTree).indexOf(first) !== -1) {
    var value = valueTree[first];

    if (typeof value === 'object' && !Array.isArray(value)) {
      doRemoveFromValueTree(value, segments);

      if (Object.keys(value).length === 0) {
        delete valueTree[first];
      }
    }
  }
}
/**
 * A helper function to get the configuration value with a specific settings path (e.g. config.some.setting)
 */


export function getConfigurationValue(config, settingPath, defaultValue) {
  function accessSetting(config, path) {
    var current = config;

    var _iterator = _createForOfIteratorHelper(path),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var component = _step.value;

        if (typeof current !== 'object' || current === null) {
          return undefined;
        }

        current = current[component];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return current;
  }

  var path = settingPath.split('.');
  var result = accessSetting(config, path);
  return typeof result === 'undefined' ? defaultValue : result;
}
export function getConfigurationKeys() {
  var properties = Registry.as(Extensions.Configuration).getConfigurationProperties();
  return Object.keys(properties);
}
export function getDefaultValues() {
  var valueTreeRoot = Object.create(null);
  var properties = Registry.as(Extensions.Configuration).getConfigurationProperties();

  for (var key in properties) {
    var value = properties[key].default;
    addToValueTree(valueTreeRoot, key, value, function (message) {
      return console.error("Conflict in default settings: ".concat(message));
    });
  }

  return valueTreeRoot;
}